var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeGroup2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M14.286 13.3H12.38V19H9.524v-4.75h-3.81V19H2.857v-5.7H.952L7.62 7.6l6.667 5.7zM3.81 0l3.809 3.8h-.952v2.85H4.762V3.8H2.857v2.85H.952V3.8H0L3.81 0zm11.428.95L20 5.7h-.952v3.8H16.19V6.65h-1.904V9.5h-1.581l-1.276-1.073V5.7h-.953L15.238.95z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeGroup2);
export default __webpack_public_path__ + "static/media/home-group-2.73b3b671d73d40b2d24cc703970f8b31.svg";
export { ForwardRef as ReactComponent };